import { render, staticRenderFns } from "./WikiContent.vue?vue&type=template&id=657b7c81"
import script from "./WikiContent.vue?vue&type=script&lang=js"
export * from "./WikiContent.vue?vue&type=script&lang=js"
import style0 from "./WikiContent.vue?vue&type=style&index=0&id=657b7c81&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports